import React from 'react';
import { SpeakerWaveIcon } from '@heroicons/react/24/solid'; // Importar el icono de volumen

const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

const MeditationPlayer = ({ 
    displayedPhase, 
    timeLeft, 
    onStop, 
    totalDuration, 
    timeElapsed, 
    isIntro = false,
    backgroundVolume, // --- NUEVO: Recibir prop de volumen ---
    onVolumeChange,   // --- NUEVO: Recibir manejador de volumen ---
}) => {
    const CurrentIcon = displayedPhase.icon;
    const progressPercentage = totalDuration > 0 ? (timeElapsed / totalDuration) * 100 : 0;

    return (
        <div className="flex flex-col items-center justify-center h-full text-center text-white animate-fade-in p-4 w-full">
            
            {!isIntro && (
                <div className="w-full max-w-lg mb-8">
                    <p className="text-purple-300 text-sm mb-2">Progreso Total</p>
                    <div className="w-full bg-gray-700 rounded-full h-2.5">
                        <div className="bg-purple-500 h-2.5 rounded-full transition-all duration-1000 linear" style={{ width: `${progressPercentage}%` }}></div>
                    </div>
                </div>
            )}

            <div className="flex flex-col items-center justify-center bg-gray-900 p-8 md:p-12 rounded-full border-4 border-purple-500/30 w-80 h-80 md:w-96 md:h-96">
                <CurrentIcon className="w-20 h-20 md:w-24 md:h-24 text-yellow-400 mb-4" />
                
                <h1 className="text-3xl md:text-4xl font-bold mb-2">
                    {displayedPhase.name}
                </h1>
                
                {isIntro ? (
                    <p className="text-2xl text-gray-400 mt-4 animate-pulse">Iniciando...</p>
                ) : (
                    <p className="text-5xl md:text-7xl font-mono font-bold text-purple-300 my-4">
                        {formatTime(timeLeft)}
                    </p>
                )}

                <p className="text-gray-400 text-sm max-w-xs px-4">
                    {displayedPhase.description}
                </p>
            </div>

            {/* --- NUEVO: Control de volumen durante la reproducción --- */}
            {!isIntro && (
                <div className="w-full max-w-sm mt-8 p-4 bg-gray-800/50 rounded-lg">
                    <label htmlFor="player-volume" className="block text-white text-sm font-bold mb-2">Ajustar Volumen de Fondo</label>
                    <div className="flex items-center gap-3">
                        <SpeakerWaveIcon className="w-5 h-5 text-purple-300"/>
                        <input
                            id="player-volume"
                            type="range"
                            min="0"
                            max="1"
                            step="0.05"
                            value={backgroundVolume}
                            onChange={(e) => onVolumeChange(e.target.value)}
                            className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-purple-500"
                        />
                    </div>
                </div>
            )}

            <button
                onClick={onStop}
                className="mt-8 px-8 py-3 bg-red-600/80 text-white font-bold rounded-lg hover:bg-red-700 transition-colors"
            >
                Finalizar Meditación
            </button>
        </div>
    );
};

export default MeditationPlayer;